const splitGluedTableRows = (text: string): string => text
  .replace(/\|\s*\|\|/g, '|\n|')
  .replace(/\|\|/g, '|\n|');

export const normalizeMarkdownTables = (content?: string | null): string => {
  if (!content)
  {
    return '';
  }

  if (!content.includes('|'))
  {
    return content;
  }

  const parts = content.split(/(```[\s\S]*?```)/);
  return parts
    .map((part) =>
    {
      if (part.startsWith('```'))
      {
        return part;
      }

      return splitGluedTableRows(part);
    })
    .join('');
};
